module.exports = __webpack_public_path__ + "static/3HOVER-7d0218b39ba9285baa165acebb461c42.png";